import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import emptyImg from './../../assets/img/empty-item.svg';
import { StyledEmptyItem } from './EmptyItem.styles';

const EmptyItem = ({ title, hasDescription = true }) => {
  const { t } = useTranslation();
  return (
    <StyledEmptyItem>
      <div className={classNames('empty-item')}>
        <img id='EmptyItem' src={emptyImg} alt='' />
        <p>{title || t('content:thereAreNoResultsForYourSearch')}</p>
        <div>
          {hasDescription && (
            <Trans i18nKey='content:expandYourSearch'>
              <span
                onClick={() => {
                  document
                    .getElementById('header-JalaliRangePicker-btn')
                    .click();
                }}
              ></span>

              <span
                onClick={() => {
                  document.getElementById('layout-filter-btn').click();
                }}
              ></span>
            </Trans>
          )}
        </div>
      </div>
    </StyledEmptyItem>
  );
};

EmptyItem.propTypes = {
  title: PropTypes.string,
  hasDescription: PropTypes.bool,
};

export default EmptyItem;
